module.exports = __webpack_public_path__ + "media/images/default_avatar-dd30aed4ba118c19d081f6011c282d50.jpg";